import { useState, useEffect, Children } from 'react';
var defaultMaxNumberOfItemsPerSlide = 4;
var gap = 16;
export var getCurrentItemsPerSlide = function (width, widthForCarouselItem) {
    if (!width)
        return defaultMaxNumberOfItemsPerSlide;
    var itemsPerSlideBeforeGapSubtraction = Math.floor(width / widthForCarouselItem);
    var widthMinusItemsGap = width - (gap * itemsPerSlideBeforeGapSubtraction - 1);
    var itemsPerSlideAfterGapSubtraction = Math.floor(widthMinusItemsGap / widthForCarouselItem);
    return itemsPerSlideAfterGapSubtraction;
};
var splitItemsIntoSlides = function (items, currentItemsPerSlide, oneItemPerSlideOnly) {
    if (oneItemPerSlideOnly)
        return items.map(function (item) { return [item]; });
    var deleteCount = currentItemsPerSlide;
    var slides = [];
    while (items.length > 0) {
        var chunk = items.splice(0, deleteCount);
        slides.push(chunk);
    }
    return slides;
};
/**
 * NOTE: `cssScrollSnapOnly` carousels will always be 1 item per slide
 */
export var useCurrentItemsPerSlide = function (_a) {
    var width = _a.width, arrayChildren = _a.arrayChildren, cssScrollSnapOnly = _a.cssScrollSnapOnly, widthForCarouselItem = _a.widthForCarouselItem, oneItemPerSlide = _a.oneItemPerSlide;
    var totalItems = Children.count(arrayChildren);
    var oneItemPerSlideOnly = oneItemPerSlide || cssScrollSnapOnly || totalItems === 1;
    var initialItemsPerSlide = oneItemPerSlideOnly ? 1 : defaultMaxNumberOfItemsPerSlide;
    var _b = useState(initialItemsPerSlide), currentItemsPerSlide = _b[0], setCurrentItemsPerSlide = _b[1];
    var slides = splitItemsIntoSlides(arrayChildren, currentItemsPerSlide, oneItemPerSlideOnly);
    useEffect(function () {
        // Don't calculate items per slide if only one item is passed
        if (oneItemPerSlideOnly)
            return;
        if (!width)
            return;
        var currentItemsPerSlide = getCurrentItemsPerSlide(width, widthForCarouselItem);
        var isTotalItemsLessThanCalculatedItemsPerSlide = totalItems <= currentItemsPerSlide;
        var newCurrentItemsPerSlide = isTotalItemsLessThanCalculatedItemsPerSlide
            ? totalItems
            : getCurrentItemsPerSlide(width, widthForCarouselItem);
        setCurrentItemsPerSlide(newCurrentItemsPerSlide);
    }, [width, totalItems, oneItemPerSlideOnly, widthForCarouselItem]);
    return {
        slides: slides,
        currentItemsPerSlide: currentItemsPerSlide,
    };
};
